import * as z from "zod/v4";

export const deletePurchaseOrderView = {
  name: "deletePurchaseOrderView" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ success: z.boolean() }),
};
